'use client'

import useAppsFlyer from '@/hooks/useAppsFlyer'
import React, { useState } from 'react'
import CustomButton from './CustomButton'
import QRCodeGenerator from '../QRCodeGenerator'
import { useT } from '@/phrase/hooks/useT'

interface DownloadCTAProps {
  title?: string
}

const DownloadCTA = ({ title = 'landing_fdwapp_cta' }: DownloadCTAProps) => {
  const t = useT()

  const { generatedUrl } = useAppsFlyer()
  const [showQr, setShowQr] = useState<boolean>(false)

  //   const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //     if (isLoading) {
  //       e.preventDefault()
  //       return
  //     }

  //     // Optional: Add tracking here
  //     // console.log('Navigating to:', generatedUrl)
  //   }

  return (
    <div className="relative">
      <div
        onClick={() => {
          setShowQr(true)
        }}
      >
        <div
          className="hidden md:flex"
          onClick={() => {
            setShowQr(true)
          }}
        >
          <CustomButton title={t(title)} className="uppercase" />
        </div>
        <div className="flex md:hidden justify-center">
          <CustomButton
            className="uppercase"
            title={t(title)}
            onClickUrl={generatedUrl.clickURL}
          />
        </div>
      </div>
      {showQr && <QRCodeGenerator url={generatedUrl.clickURL} title={title} />}
    </div>
  )
}

export default DownloadCTA
